export default __webpack_public_path__ + "resources/icons/n121-68b8.png";